import {systemMessage} from "../systemMessage";
import axios from 'axios';
import {useAuth} from '../AuthContext';
import API_URL from '../config/apiConfig';
import Swal from 'sweetalert2';
import useErrorHandler from './useErrorHandler';

const useSendMessage = (
    inputValue,
    setInputValue,
    setIsLoading,
    setSentImageUrls,
    setUploadedImageUrls,
    uploadedImageUrls,
    messages,
    setMessages
) => {
  const authInfo = useAuth();
  const userId = authInfo.authToken?.userId;
  const userName = authInfo.authToken?.userName;
  const handleError = useErrorHandler();




  const handleSend = async (event, text) => {

    if (event) event.preventDefault();
    setIsLoading(true);

    if (!userId) {
      await handleError('Utilisateur non authentifié', 'Veuillez vous reconnecter.', 'handleSend - auth');
      setIsLoading(false);
      return;
    }

    const messageContent = [];
    if (text?.trim()) {
      messageContent.push({ type: 'text', text: text.trim() });
    }

    if (Array.isArray(uploadedImageUrls)) {
      uploadedImageUrls.forEach(url => {
        if (url) {
          messageContent.push({ type: 'image_url', image_url: { url } });
        }
      });
    }

    if (messageContent.length === 0) {
      Swal.fire('Erreur', 'Veuillez entrer un message ou une image', 'warning');
      setIsLoading(false);
      return;
    }

    const newMessage = { role: 'user', content: messageContent };
    const newMessages = [...messages, newMessage];
    setMessages(newMessages);
    setInputValue('');
    setTimeout(() => setUploadedImageUrls([]), 500);

    // Enregistrement du message texte
    try {
      const textContent = messageContent.find(m => m.type === 'text')?.text || '';
      await axios.post(`${API_URL}/messages`, {
        user: userName || 'User',
        content: textContent,
        role: 'user',
        userId
      });
    } catch (error) {
      await handleError('Erreur d\'enregistrement', 'Impossible d\'enregistrer le message utilisateur.', 'handleSend - save user message', error);
    }

    // Enregistrement des images
    const imageMessages = messageContent.filter(m => m.type === 'image_url');
    for (const image of imageMessages) {
      try {
        await axios.post(`${API_URL}/images`, {
          userId,
          imagePath: image.image_url.url
        });
      } catch (error) {
        await handleError('Erreur image', 'Échec de l’enregistrement d’une image.', 'handleSend - save image', error);
      }
    }

    // Appel à OpenAI
    try {
      const payload = {
        model: 'o4-mini-2025-04-16',
        messages: [systemMessage, ...newMessages],
        response_format: { type: 'text' },
        reasoning_effort: 'medium'
      };
  console.log(payload)
  
      //const response = await fetch('https://api.openai.com/v1/chat/completions', {
      //  method: 'POST',
      //  headers: {
      //    'Authorization': `Bearer ${process.env.REACT_APP_API_KEY_OAI}`,
      //    'Content-Type': 'application/json'
     //   },
     //   body: JSON.stringify(payload)
    //  });
    
    const response = await fetch('https://www.sophia.aiexpertys.fr/api/openai/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error?.message || 'Réponse invalide de l’assistant');
      }

      const data = await response.json();
      const assistantMessage = {
        role: 'assistant',
        content: data.choices[0].message.content
      };

      setMessages(prev => [...prev, assistantMessage]);

      // Enregistrement du message assistant
      try {
        await axios.post(`${API_URL}/messages`, {
          user: 'Assistant',
          content: assistantMessage.content,
          role: 'assistant',
          userId
        });
      } catch (error) {
        await handleError('Erreur assistant', 'Le message de l’assistant n’a pas pu être sauvegardé.', 'handleSend - save assistant message', error);
      }

    } catch (error) {
      await handleError('Erreur IA', 'Impossible d\'obtenir une réponse de l’assistant.', 'handleSend - OpenAI call', error);
    } finally {
      setIsLoading(false);
      setSentImageUrls(prev => [...prev, ...uploadedImageUrls]);
    }
  };
  return { handleSend };
};

export default useSendMessage;
